import { CHALLENGE_MAP, CHALLENGE_MAP_PULLUP } from "../../challengeConstants";
import teamPoints from "./TeamPoints";
import buddyPoints from './BuddyPoints';
import Challenge11Points from './Challenge11Points';
import Challenge12TeamPoints from './Challenge12TeamPoints'

const getPointsMapping = (challengeName) => (
  {
    'Bodykey Challenge 2024': teamPoints,
    'Bodykey ME & Buddy Challenge 2025': buddyPoints,
    'Bodykey Challenge 2025': Challenge11Points,
    'Bodykey Challenge 2026': Challenge12TeamPoints
  }[challengeName] || Challenge12TeamPoints
)

export const calculateUserPosition = (userSteps, eventName) => {

  const stepsToAdd = parseInt(userSteps);
  if (isNaN(stepsToAdd)) return 0;

  let targetPosition = 0;
  let minStepDifference = Infinity;

  // Iterate over points to find the nearest valid target position
  getPointsMapping(eventName).forEach((point, index) => {
    if (userSteps >= point.totalStep) {
      targetPosition = index;
    } else {
      return;
    }
  });
  return targetPosition;
};


export const fadeOutMainPoints = (targetPosition = 0, eventName) => {
  let fadeOutList = [];

  [...Array(targetPosition + 1)].forEach((_, i) => {
    if (getPointsMapping(eventName)[i].type === "main") {
      fadeOutList.push(i);
    }
  });

  return fadeOutList;
};

export const getStepsPercentage = (steps, totalSteps) => Math.round(steps * 100 / totalSteps);
export const getStepsActiveIndex = (steps) => Math.min(CHALLENGE_MAP_PULLUP.TOTAL_MILESTONES, Math.floor(steps * 7 / CHALLENGE_MAP_PULLUP.TOTAL_TARGET));
